<template>
    <Modal :show="show" class="text-center" @close="close()">
        <ModalSuccess v-if="success" title="Kit successfully sent" :bodyText="successBody" buttonText="OK" @close="close()" />
        <Loader v-if="sending" />
        <div class="modal-main" style="max-width:500px" v-if="!success">
            
            <div class="modal-header">


                <h2 class="modal-title" v-if="giveToAChild">Send kit to Parent/Guardian account</h2>
                <h2 class="modal-title" v-else >Give this kit to someone else</h2>
            </div>

            <div class="modal-body">

                <transition name="slide-fade">
                <div v-if="error" class="alert alert-danger" role="alert">
                  {{error}}
                </div>
              </transition>

                <p class="text-center" v-if="giveToAChild">Email this voucher to your Parent/Guardian account. This will allow the kit to be redeemed on behalf of your child or dependant.</p>
                <p class="text-center" v-else>Email this voucher to someone else which will allow them to redeem this kit and start their Microba Journey</p>

                <div class="share-voucher share-voucher-copy" v-if="outVoucher != ''">
                    {{outVoucher}}
                    <button type="button" class="btn plain"
                      v-clipboard:copy="outVoucher"
                      v-clipboard:success="onCopy"><em>Copy</em></button>
                </div>

                <br><br>

                <div class="form-group input-inline" v-if="voucher != '' && sending == false">
                    <input type="email" v-model="email" class="form-control" placeholder="Enter their email address">
                    <button class="btn btn-primary" v-on:click="sendVoucher">Send</button>
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn btn-link" v-on:click="close" :disabled="sending == true">Cancel</button>
            </div>

        </div>

    </Modal>
</template>

<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import Modal from '@/components/models/Modal'
import ModalSuccess from '@/components/models/components/ModalSuccess'
import Loader from '@/components/elements/Loader'

Vue.use(VueClipboard)
export default {
  name: 'ModalSendAKit',
  props: ['kitID', 'voucherCode', 'giveChild'],
  extends: Modal,
  components: {
    Modal,
    ModalSuccess,
    Loader
  },
  data: function () {
    return {
      loadingVoucher: true,
      voucher: '',
      error: null,
      sending: false,
      email: '',
      success: false
    }
  },
  computed: {
    giveToAChild () {
      return this.giveChild
    },
    successBody () {
      return 'An email with this kit voucher code has been sent to ' + this.email
    },
    outVoucher () {
      if (this.voucher.length > 0) {
        return this.voucher
      }
      return this.voucherCode
    }

  },
  methods: {
    onShow: function () {
      this.voucher = ''
      this.sending = false
      this.success = false
      this.getVoucher()
    },
    onCopy: function () {
      alert('copy to clipboard')
    },
    getVoucher: function () {
      this.loadingVoucher = true
      this.error = null
      const payload = {
        kitId: this.kitID
      }
      this.$store.dispatch('getVoucher', payload).then(success => {
        this.voucher = success.data.voucherCode
        this.loadingVoucher = false
      }).catch(error => {
        console.log('error', error)
        this.loadingVoucher = false
        this.error = error.response.data.message
      })
    },
    sendVoucher: function () {
      const payload = {
        kitId: this.kitID,
        voucher: this.voucher,
        email: this.email
      }
      this.sending = true
      this.$store.dispatch('sendKit', payload).then(success => {
        this.sending = false
        this.success = true
        this.$store.dispatch('getUserKits')
        this.$store.dispatch('getSentKits')
      }).catch(error => {
        // Refresh regardless
        this.$store.dispatch('getUserKits')
        this.$store.dispatch('getSentKits')
        this.sending = false
        this.error = error.response.data.message
      })
    }
  }
}
</script>

<style scoped lang="scss">
    .modal-body {
        padding-bottom:1rem;
    }
    .input-inline button{
      margin-bottom: 0 !important;
    }
</style>
 


// WEBPACK FOOTER //
// src/components/models/ModalSendAKit.vue